if (!window.Eurus.loadedScript.has('product-recommendations.js')) {
  window.Eurus.loadedScript.add('product-recommendations.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductRecommendationsSection', (sectionId) => ({
        loading: false,
        currentTab: 1,
        sectionId: sectionId,
        carouselCanPrev: false,
        carouselCanNext: false,
        init() {
          document.addEventListener(`eurus:${this.sectionId}:splide-ready`, () => {
            this.bindActiveCarouselArrows();
          });
          document.addEventListener(`${this.sectionId}:tab-changed`, () => {
            this.$nextTick(() => this.bindActiveCarouselArrows());
          });
          this.$nextTick(() => this.bindActiveCarouselArrows());
        },
        getActiveSplide() {
          const id = this.currentTab === 2
            ? `recently-viewed-tab--${this.sectionId}`
            : `x-product-recommendation-${this.sectionId}`;
          const el = document.getElementById(id);
          return el && el.splide ? el.splide : null;
        },
        syncCarouselArrows() {
          const splide = this.getActiveSplide();
          if (!splide || !splide.Components || !splide.Components.Controller) {
            this.carouselCanPrev = false;
            this.carouselCanNext = false;
            return;
          }
          const controller = splide.Components.Controller;
          this.carouselCanPrev = controller.getPrev() !== -1;
          this.carouselCanNext = controller.getNext() !== -1;
        },
        bindActiveCarouselArrows() {
          const splide = this.getActiveSplide();
          this.syncCarouselArrows();
          if (!splide || splide.__carouselArrowsBound) return;
          splide.__carouselArrowsBound = true;
          splide.on('moved resized updated', () => this.syncCarouselArrows());
        },
        carouselPrev() {
          const splide = this.getActiveSplide();
          if (!splide) return;
          splide.go('<');
          this.syncCarouselArrows();
        },
        carouselNext() {
          const splide = this.getActiveSplide();
          if (!splide) return;
          splide.go('>');
          this.syncCarouselArrows();
        }
      }));

      Alpine.store('xProductRecommendations', {
        loading: false,
        listOfUpsellProducts: [],
        el: '',
        listUpsellId: [],
        productCount: 0,
        async loadUpsell(el, url, listId, limit, maxItems) {
          this.el = el;
          this.loading = true;
          this.listOfUpsellProducts = [];
          this.productCount = 0;
          this.listUpsellId = [];         
          for (let i = 0; i < listId.length; i++) {
            if (this.productCount >= maxItems) {
              break;
            }    
            try {
              const response = await fetch(`${url}&product_id=${listId[i]}&limit=${limit}&intent=related`);
              const text = await response.text();
              const html = document.createElement('div');
              html.innerHTML = text;
              const des = document.querySelector('.cart-upsell-carousel');
              const src = html.querySelector('.cart-upsell-carousel')
              if(src && des) des.innerHTML = src.innerHTML
              const recommendations = html.querySelector('.product-recommendations');
      
              if (recommendations && recommendations.innerHTML.trim().length) {
                const newUpsellProducts = recommendations.querySelectorAll('template[x-teleport="#cart-upsell-drawer"], template[x-teleport="#cart-upsell"]');
                this.listOfUpsellProducts = [...newUpsellProducts, ...this.listOfUpsellProducts];
      
                for (let index = 0; index < this.listOfUpsellProducts.length; index++) {
                  if (this.productCount >= maxItems) {
                    break;
                  }
                  
                  const element = this.listOfUpsellProducts[index];
                  const elementId = new DOMParser().parseFromString(element.innerHTML, 'text/html').querySelector('.hover-text-link, .link-product-variant').id;
                  
                  if (!this.listUpsellId.includes(elementId)) {
                    this.listUpsellId.push(elementId);
                    el.appendChild(element);
                    this.productCount++;
                  }
                }
      
                if (recommendations.classList.contains('main-product')) {
                  el.className += ' mb-4 md:mb-6 border-y border-solid accordion empty:border-b-0';
                }
              } else if (recommendations && recommendations.classList.contains('main-product')) {
                recommendations.classList.add("hidden");
                el.innerHTML = recommendations.innerHTML;
              }
            } catch (e) {
              console.error(e);
            } finally {
              this.loading = false;
            }
          }
        },
        load(el, url) {
          this.loading = true;
          fetch(url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('.product-recommendations');
              if (recommendations && recommendations.innerHTML.trim().length) {
                requestAnimationFrame(() => {
                  el.innerHTML = recommendations.innerHTML;
                });
                if (recommendations.classList.contains('main-product')) {
                  el.className += ' mb-4 md:mb-6 border-y border-solid accordion empty:border-b-0';
                }
              } else if (recommendations.classList.contains('main-product')) {
                requestAnimationFrame(() => {
                  setTimeout(() => {
                    recommendations.classList.add("hidden");
                    el.innerHTML = recommendations.innerHTML;
                  }, 0)
                });
              }
            })
            .catch(e => {
              console.error(e);
            });
        }
      })     
    });
  });
}
